import {SystemStatus} from '../../../core/enum';
import {MapJSON} from '@verihubs/pandora';
import moment from 'moment';
export interface SystemEntity {
  id: string;
  service: string;
  parentId: string | null;
  status: SystemStatus;
  notes: string;
  createdAt: Date;
  children?: SystemEntity[];
}

export namespace SystemEntity {
  export function fromJSON(json: MapJSON): SystemEntity {
    const root: SystemEntity = {
      id: json['id'],
      service: json['service_name'],
      parentId: json['parent_id'],
      status: SystemStatus.toEnum(json['status']),
      notes: json['notes'],
      createdAt: moment.utc(json['created_at']).toDate(),
      children: [],
    };

    if (Array.isArray(json['child']) && json['child'].length > 0) {
      json['child'].forEach(val => {
        root.children.push(SystemEntity.fromJSON(val));
      });
    }

    return root;
  }
}
